import { Card, CardContent } from "./ui/card";
import { motion } from "framer-motion";

interface ChoiceCardProps {
  emoji: string;
  title: string;
  description?: string;
  selected: boolean;
  onClick: () => void;
}

export function ChoiceCard({ emoji, title, description, selected, onClick }: ChoiceCardProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <Card 
        className={`cursor-pointer transition-all duration-200 ${
          selected 
            ? 'ring-2 ring-coral bg-coral/5 border-coral' 
            : 'hover:shadow-md border-border'
        }`}
        onClick={onClick}
      >
        <CardContent className="p-6 text-center">
          <div className="text-3xl mb-3">{emoji}</div>
          <h3 className="font-medium mb-1">{title}</h3>
          {description && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
